import { Dialog } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import { useCallback } from 'react'
import { useEffect } from 'react'
import ReactMoreReadLess from '../../common/ReadMoreReadLess/ReactMoreReadLess'
import GradeIcon from '@mui/icons-material/Grade'
import backButton from '../../../assets/images/icons/back-black-icon.svg'
import useHash from '../../common/customHooks/useHash'

export default function ExpandDetail(props) {
  //   useEffect(() => {}, [])
  console.log('close Detail Page>>>', props.open)

  // Restricting device back button
  let tags = []
  {
    props.contentType === 'hotel_amenities' &&
      props.value.map((item) => {
        {
          item.values.map((innerItem) => {
            tags.push(innerItem.value)
          })
        }
      })
  }

  const [hash, setHash] = useHash()
  useEffect(() => {
    // setHash('#see-all')
  }, [])

  // window.history.pushState(null, null, window.location.href)
  // window.onpopstate = function () {
  //   console.log('close Detail Page>>>', props.open)
  //   if (!props.open) {
  //     props.handleDetailPageClose()
  //   } else {
  //   }

  //   props.handleExpandPageClose()
  //   window.history.go(1)
  // }
  return (
    <div
      style={{
        // padding: '16px 20px 32px 20px',
        position: 'relative',
      }}
    >
      <Dialog
        fullScreen
        open={props.open}
        keepMounted
        hideBackdrop={true}
        // TransitionComponent={Transition}
        className="modal-width"
        PaperProps={{
          style: {
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
            padding: '48px 20px 48px 20px',
            // marginBottom: '24px',
          },
        }}
      >
        {/*------- Content---------- */}
        {/*------- Hotel-Review---------- */}
        {props.contentType === 'reviews' && (
          <div
            style={
              {
                // padding: '16px 20px 32px 20px',
                // background: layout.color ? `#${layout.color}` : '',
                // background: '#00ff00',
              }
            }
          >
            <div
              style={{
                top: '0px',
                marginBottom: '10px',
                textAlign: 'left',
                color: 'var(--gray100)',
                display: 'flex',
                position: 'fixed',
                background: 'white',
                left: '5px',
                paddingTop: '10px',
                cursor: 'pointer',
              }}
              className="dynamic-width"
              onClick={() => {
                props.handleExpandPageClose()
              }}
            >
              <img src={backButton} alt="back"></img>
              <p className="title2">{props.layout.display_name}</p>
            </div>

            {/* all reviews */}
            <div style={{ marginTop: '60px' }}>
              {props.value.map((item, index) => {
                return (
                  <div style={{ marginBottom: '24px' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                      }}
                    >
                      <img
                        src={item.icon_url}
                        alt=""
                        style={{
                          marginRight: '8px',
                          width: '20px',
                          height: 'auto',
                        }}
                      ></img>
                      <div>
                        <div
                          style={{
                            display: 'block',
                            alignItems: 'center',
                            color: 'var(--gray80)',
                          }}
                        >
                          <p
                            className="headline2"
                            style={{
                              margin: '0px',
                            }}
                          >
                            {item.source_title}
                          </p>
                        </div>
                      </div>
                    </div>
                    {item.rating_text && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          color: 'var(--gray60)',
                        }}
                      >
                        <GradeIcon
                          sx={{
                            mr: 0.5,
                            fontWeight: 400,
                            fontSize: 15,
                          }}
                        />

                        <p className="body3">{item.rating_text}</p>
                      </div>
                    )}

                    <div
                      style={{
                        display: 'block',
                        alignItems: 'center',
                        color: 'var(--gray100)',
                      }}
                    >
                      <p
                        className="body2"
                        style={
                          // firstValue.rating_text
                          //   ? {
                          //       marginTop: '-0.5rem',
                          //     }
                          //   : { marginTop: '0.5rem' }
                          {
                            marginTop: item.rating_text ? '0px' : '8px',
                            lineHeight: '150%',
                          }
                        }
                      >
                        <ReactMoreReadLess
                          moreText={'More'}
                          lessText={'Less'}
                          showArrow={true}
                          lines={'4'}
                        >
                          {item.description}
                        </ReactMoreReadLess>
                      </p>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )}

        {/*------- Hotel-About us---------- */}
        {props.contentType === 'about_hotel' && (
          <div>
            <div>
              <div
                style={{
                  top: '0px',
                  marginBottom: '10px',
                  textAlign: 'left',
                  color: 'var(--gray100)',
                  display: 'flex',
                  position: 'fixed',
                  background: 'white',
                  left: '5px',
                  paddingTop: '10px',
                  cursor: 'pointer',
                }}
                className="dynamic-width"
                onClick={() => {
                  props.handleExpandPageClose()
                }}
              >
                <img src={backButton} alt="back"></img>
                <p className="title2">{props.layout.display_name}</p>
              </div>

              <div
                style={{
                  textAlign: 'left',
                  color: 'var(--gray80)',
                  marginTop: '60px',
                }}
              >
                <pre
                  className="body2"
                  style={{ whiteSpace: 'pre-line', lineHeight: '150%' }}
                >
                  {props.value}
                </pre>
              </div>
            </div>
          </div>
        )}

        {/*------- Hotel-Amenties---------- */}
        {props.contentType === 'hotel_amenities' && (
          <div>
            <div
              style={{
                top: '0px',
                marginBottom: '10px',
                textAlign: 'left',
                color: 'var(--gray100)',
                display: 'flex',
                position: 'fixed',
                background: 'white',
                left: '5px',
                cursor: 'pointer',
                paddingTop: '10px',
              }}
              className="dynamic-width"
              onClick={() => {
                props.handleExpandPageClose()
              }}
            >
              <img src={backButton} alt="back"></img>
              <p className="title2">{props.layout.display_name}</p>
            </div>

            <div style={{ marginTop: '60px' }}>
              {tags.map((tag, index) => {
                return <p key={index}>{tag}</p>
              })}
            </div>
          </div>
        )}

        {/*------- Activity-What you'll do---------- */}
        {props.contentType === "What you'll do" && (
          <div>
            <div
              style={
                {
                  // padding: '16px 20px 32px 20px',
                  // background: layout.color ? `#${layout.color}` : '',
                  // background: '#ff0000',
                }
              }
            >
              <div
                style={{
                  top: '0px',
                  marginBottom: '10px',
                  textAlign: 'left',
                  color: 'var(--gray100)',
                  display: 'flex',
                  position: 'fixed',
                  background: 'white',
                  left: '5px',
                  paddingTop: '10px',
                  cursor: 'pointer',
                }}
                className="dynamic-width"
                onClick={() => {
                  props.handleExpandPageClose()
                }}
              >
                <img src={backButton} alt="back"></img>
                <p className="title2">{props.layout.display_name}</p>
              </div>
              <div
                style={{
                  textAlign: 'left',
                  color: 'var(--gray80)',
                  marginTop: '60px',
                }}
              >
                <pre
                  className="body2"
                  style={{
                    whiteSpace: 'pre-line',
                    lineHeight: '150%',
                    wordWrap: 'break-word',
                  }}
                >
                  {props.value.text}
                </pre>
              </div>
            </div>
          </div>
        )}

        {/*------- Activity-Important info---------- */}
        {props.contentType === 'Important info' && (
          <div>
            <div
              style={{
                top: '0px',
                marginBottom: '10px',
                textAlign: 'left',
                color: 'var(--gray100)',
                display: 'flex',
                position: 'fixed',
                background: 'white',
                left: '5px',
                paddingTop: '10px',
                cursor: 'pointer',
              }}
              className="dynamic-width"
              onClick={() => {
                props.handleExpandPageClose()
              }}
            >
              <img src={backButton} alt="back"></img>
              <p className="title2">{props.layout.display_name}</p>
            </div>
            <ul
              style={{
                padding: '40px 20px 0px 20px',
              }}
            >
              {props.value.map((item, index) => {
                return (
                  <li
                    style={{
                      textAlign: 'left',
                      color: 'var(--gray80)',
                    }}
                  >
                    <p
                      className="body2"
                      style={{
                        margin: '16px 0px 16px 8px',
                        lineHeight: '150%',
                      }}
                    >
                      {item}
                    </p>
                  </li>
                )
              })}
            </ul>
          </div>
        )}

        {/*------- Activity-Additional info---------- */}
        {props.contentType === 'Additional info' && (
          <div>
            <div
              style={
                {
                  // padding: '16px 20px 32px 20px',
                  // background: layout.color ? `#${layout.color}` : '',
                  // background: '#ff0000',
                }
              }
            >
              <div
                style={{
                  top: '0px',
                  marginBottom: '10px',
                  textAlign: 'left',
                  color: 'var(--gray100)',
                  display: 'flex',
                  position: 'fixed',
                  background: 'white',
                  left: '5px',
                  paddingTop: '10px',
                  cursor: 'pointer',
                }}
                className="dynamic-width"
                onClick={() => {
                  props.handleExpandPageClose()
                }}
              >
                <img src={backButton} alt="back"></img>
                <p className="title2">{props.layout.display_name}</p>
              </div>
              <div
                style={{
                  textAlign: 'left',
                  color: 'var(--gray80)',
                  marginTop: '60px',
                }}
              >
                <pre
                  className="body2"
                  style={{
                    whiteSpace: 'pre-line',
                    lineHeight: '150%',
                    wordWrap: 'break-word',
                  }}
                >
                  {props.value.text ? props.value.text : props.value[0]}
                </pre>
              </div>
            </div>
          </div>
        )}
      </Dialog>
    </div>
  )
}
